
const init = () => {

    const buttons = document.querySelectorAll('.button:not(.contentUpdated), .button-rounded:not(.contentUpdated)');

    if(buttons){
        buttons.forEach((item) => {
            let itemHtml = item.innerHTML;
            item.innerHTML = `  <span class="button-content button-content--default">${itemHtml}</span>
                                <span class="button-content button-content--hover">${itemHtml}</span>`;

            item.classList.add('contentUpdated');
        });
    }
};

export default { init };